<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
                <div class="header-body">
                    <div class="row align-items-center py-4">
                        <div class="col-lg-8 col-6">
                            <h2>Approval Pending</h2>
                        </div>
                        <div class="col-lg-4 col-6 text-right bid">
                            <button @click="denyAll()" type="button" class="btn btn-danger mr-3"><i
                                    class="fa fa-times-circle"></i>Deny</button>    
                            <button @click="approveAll()" type="button" class="btn btn-success mr-3"><i
                                    class="fa fa-check"></i>APPROVE</button>
                               
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="container-fluid mt--6 filter-show">
                <div class="card w-100 p-2 mb-2  d-inline-block">
                    <div class="d-flex justify-content-between">
                        <h5 class="ml-3">Filters</h5>
                        <span class="btn btn-link" @click="showFilters = !showFilters">
                            <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']"></i> {{ showFilters
                                ? 'Hide' : 'Show' }} Filters
                        </span>
                    </div>
                    <div class="row" v-if="showFilters">
                        <div class="col-lg-12">
                            <form class="row">
                                <div class="col-md-6 col-lg-3">
                                    <label>TRADER</label>
                                    <multiselect
                                        v-model="filterTrader"
                                        placeholder="Select traders"
                                        label="firstName"
                                        track-by="id"
                                        :options="traderList"
                                        @input="search"
                                        :multiple="false"
                                        :limit="3"
                                    ></multiselect>
                                </div> 
                                <div class="col-md-6 col-lg-3">
                                    <label>CUSIP</label>
                                    <input style="height: 42px" class="form-control" v-model.trim="searchValue" />
                                </div>
                                <div class="col-md-6 col-lg-3">
                                    <label>Ecn</label>
                                    <multiselect v-model="ecn" placeholder="Select ecn" :options="['IBP', 'TWD', 'TMC']"
                                        :multiple="true" @input="search" :limit="3"></multiselect>
                                </div>
                                <div class="col-md-6 col-lg-3">
                                    <button @click="clear()" type="button"
                                        class="btn btn-secondary rounded mt-4">Clear</button>
                                    <button @click="search()" type="button"
                                        class="btn btn-primary rounded mt-4">Filter</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container-fluid">
                <div class="row xsOnly">
                    <div class="col-xl-12">
                        <div class="card vh-75" id="scroll">
                            <div class="table-responsive">
                                <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt="" /></div>
                                <table class="table align-items-center table-flush table-hover bidtbl"
                                    style="min-height:125px">
                                    <thead class="thead-light psticky">
                                        <tr>
                                            <th 
                                                scope="col" 
                                                class="text-center"
                                                >SELECT</th>
                                            <th scope="col" class="sort text-center"
                                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'traderFirstName' ? 'sort-asc' : '', sortOrder == 'DESC' && sortColumn == 'traderFirstName' ? 'sort-desc' : '']"
                                                @click="sort('traderFirstName')">Trader</th>    
                                            <th scope="col" class="sort text-center"
                                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusip' ? 'sort-asc' : '', sortOrder == 'DESC' && sortColumn == 'cusip' ? 'sort-desc' : '']"
                                                @click="sort('cusip')">Cusip</th>
                                            <th scope="col" class="sort text-center"
                                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'orderQty' ? 'sort-asc' : '', sortOrder == 'DESC' && sortColumn == 'orderQty' ? 'sort-desc' : '']"
                                                @click="sort('orderQty')">QTY</th>
                                            <th scope="col" class="sort text-center"
                                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'ecn' ? 'sort-asc' : '', sortOrder == 'DESC' && sortColumn == 'ecn' ? 'sort-desc' : '']"
                                                @click="sort('ecn')">ECN</th>
                                            <!-- <th scope="col" class="sort text-center"
                                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'status' ? 'sort-asc' : '', sortOrder == 'DESC' && sortColumn == 'status' ? 'sort-desc' : '']"
                                                @click="sort('status')">STATUS</th> -->
                                            <th scope="col" class="sort text-center"
                                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'bidBy' ? 'sort-asc' : '', sortOrder == 'DESC' && sortColumn == 'bidBy' ? 'sort-desc' : '']"
                                                @click="sort('bidBy')">VALID UNTIL</th>
                                            <th scope="col" class="sort text-center"
                                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'firmUntill' ? 'sort-asc' : '', sortOrder == 'DESC' && sortColumn == 'firmUntill' ? 'sort-desc' : '']"
                                                @click="sort('firmUntill')">FIRM UNTIL</th>
                                            <th scope="col" class="sort text-center"
                                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'settleDate' ? 'sort-asc' : '', sortOrder == 'DESC' && sortColumn == 'settleDate' ? 'sort-desc' : '']"
                                                @click="sort('settleDate')">SETTLEMENT DATE</th>
                                            <th scope="col" class="sort text-center"
                                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'bondInsurer' ? 'sort-asc' : '', sortOrder == 'DESC' && sortColumn == 'bondInsurer' ? 'sort-desc' : '']"
                                                @click="sort('bondInsurer')">BOND INSURER</th>
                                            <th scope="col" class="sort text-center"
                                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusipCoupon' ? 'sort-asc' : '', sortOrder == 'DESC' && sortColumn == 'cusipCoupon' ? 'sort-desc' : '']"
                                                @click="sort('cusipCoupon')">COUPON</th>
                                            <th scope="col" class="sort text-center"
                                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'stateName' ? 'sort-asc' : '', sortOrder == 'DESC' && sortColumn == 'stateName' ? 'sort-desc' : '']"
                                                @click="sort('stateName')">STATE</th>
                                            <th scope="col" class="sort text-center"
                                                v-bind:class="[sortOrder == 'ASC' && sortColumn == 'bidPrice' ? 'sort-asc' : '', sortOrder == 'DESC' && sortColumn == 'bidPrice' ? 'sort-desc' : '']"
                                                @click="sort('bidPrice')">PRICE</th>
                                            <th scope="col" class="sort text-center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody class="list no-cursor">
                                        <tr v-if="bidwantedList.length == 0 && !loading">
                                            <td>
                                                <p class="nodata">No data available</p>
                                            </td>
                                        </tr>
                                        <tr v-for="data in bidwantedList" :key="data.id">
                                            <td class="text-center"  >
                                                <input  v-model="data.isSelect" type="checkbox" class="form-check-input" />
                                            </td>
                                            <td class="text-center">{{ data.traderFirstName }} {{ data.traderLastName }}</td>
                                            <td class="text-center"><span class="cusips">{{ data.cusip }}</span></td>
                                            <td class="text-center">{{ data.orderQty }}</td>
                                            <td class="text-center">
                                                {{ data.ecn }}
                                            </td>
                                            <!-- <td class="text-center">{{ data.status }}</td> -->
                                            <td class="text-center">{{ data.bidBy ?
                                                moment.utc(data.bidBy).local().format("hh:mm:ss a") : 'N/A' }}</td>
                                            <td class="text-center">{{ data.firmUntill ?
                                                moment.utc(data.firmUntill).local().format("hh:mm:ss a") : 'N/A' }}</td>
                                            <td class="text-center">{{ data.settleDate ?
                                                moment(data.settleDate).format("MM/DD/YYYY") : 'N/A' }}</td>
                                            <td class="text-center">
                                                {{ getAbbreviation(data.bondInsurer) }}
                                            </td>
                                            <td class="text-center">
                                                {{ data.cusipCoupon | percent(3) }}
                                            </td>
                                            <td class="text-center">
                                                {{ data.stateName }}
                                            </td>
                                            <td class="text-center">
                                                {{ data.bidPrice }}
                                            </td>
                                            <td class="text-center">
                                                <button
                                                    @click="singleApprove(data)" class="btn btn-success" type="button">
                                                    <i class="fas fa-check"></i>APPROVE
                                                </button>
                                                <button
                                                    @click="singleDeny(data)" class="btn btn-danger" type="button">
                                                    <i class="fas fa-times-circle"></i>Deny
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- Pagination-->
                                <b-pagination class="mt-4" :total-rows="totalRows" v-model="currentPage" :per-page="perPage"
                                    @input="getBidwantedList(currentPage)"></b-pagination>
                                <div class="total-records">
                                    <span>Total Records : {{ totalRows }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import config from "@/config";
import authService from "@/authService";
export default {
    name: "imsCusipComponent",
    components: {

    },
    data() {
        return {
            accessToken: null,
            loading: false,
            currentPage: 1,
            perPage: 25,
            searchValue: "",
            totalRows: 0,
            sortColumn: "id",
            sortOrder: "DESC",
            bidwantedList: [],
            createdDate: new Date(),
            showFilters: false,
            sendBidWantedModalOpen: false,
            selectedBidWanted: null,
            status: [],
            statusList: ["BID_SENDING", "BID_SENT", "ORDER_RECEIVED", "ACCEPTED", "REJECTED", "TRADED_AWAY", "SUBJECT", "TRADE_CANCELLED", "BID_CANCELLED", "BID_CANCELING", "DID_NOT_TRADE", "APPROVAL_PENDING"],
            ecn: "",
            traderList: [],
            filterTrader: null,

        };
    },
    methods: {
        approveAll(){
            let data = [];
            this.bidwantedList.forEach(bid => {
                if(bid.isSelect){
                    data.push(bid.id)
                }
            });
            if(data.length == 0){
                this.$alert("Please select any bid","","error");
                return false
            }
            var message = "Are you sure you want to approve?";
            this.$confirm(message,"","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
                this.loading = true;
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken()  }
                };
                
                this.$http
                .post(config.baseUrlAutoBidder + "/autobidder/bid-approval?isSend=true",data,auth)
                .then(() => {
                    this.loading = false;  
                    this.$alert("Bid approved successfully","","success");            
                    this.getBidwantedList();
                })
                .catch(() => {
                    this.loading = false;              
                });
            });
        },
        denyAll(){
            let data = [];
            this.bidwantedList.forEach(bid => {
                if(bid.isSelect){
                    data.push(bid.id)
                }
            });
            if(data.length == 0){
                this.$alert("Please select any bid","","error");
                return false
            }
            var message = "Are you sure you want to deny?";
            this.$confirm(message,"","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
                this.loading = true;
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken()  }
                };
                
                this.$http
                .post(config.baseUrlAutoBidder + "/autobidder/bid-approval?isSend=false",data,auth)
                .then(() => {
                    this.loading = false;  
                    this.$alert("Bid denied successfully","","success");            
                    this.getBidwantedList();
                })
                .catch(() => {
                    this.loading = false;              
                });
            });
        },
        singleApprove(bid){
            var message = "Are you sure you want to approve?";
            this.$confirm(message,"","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
                this.loading = true;
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken()  }
                };
                let data = [bid.id]
                this.$http
                .post(config.baseUrlAutoBidder + "/autobidder/bid-approval?isSend=true",data,auth)
                .then(() => {
                    this.loading = false;  
                    this.$alert("Bid approved successfully","","success");            
                    this.getBidwantedList();
                })
                .catch(() => {
                    this.loading = false;              
                });
            });
        },
        singleDeny(bid){
            var message = "Are you sure you want to deny?";
            this.$confirm(message,"","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
                this.loading = true;
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken()  }
                };
                let data = [bid.id]
                this.$http
                .post(config.baseUrlAutoBidder + "/autobidder/bid-approval?isSend=false",data,auth)
                .then(() => {
                    this.loading = false;  
                    this.$alert("Bid denied successfully","","success");            
                    this.getBidwantedList();
                })
                .catch(() => {
                    this.loading = false;              
                });
            });
        },
        sort(column) {
            this.sortColumn = column;
            this.sortOrder = this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
            this.getBidwantedList();
        },
        search() {
            this.currentPage = 1;
            this.getBidwantedList();
        },
        clearSearch() {
            this.searchValue = "";
            this.currentPage = 1;
            this.getBidwantedList();
        },
        clear() {
            this.searchValue = "";
            this.status = "";
            this.ecn = "";
            this.filterTrader = null
            this.currentPage = 1;
            this.getBidwantedList();
        },
        getBidwantedList() {
            this.loading = true;
            const auth = {
                headers: { 'org-token': authService.getOrgToken() }
            };
            let currentDate = this.moment().format("MM-DD-YYYY");
            let fromDate = this.moment(currentDate).utc().format("YYYY-MM-DD HH:mm:ss")
            const assignedBy = this.filterTrader ? this.filterTrader.id : '';
            this.$http
                .get(
                    config.baseUrlAutoBidder +
                    "/autobidder/listall?page=" +
                    this.currentPage +
                    "&size=" +
                    this.perPage +
                    "&search=" +
                    this.searchValue +
                    "&status=APPROVAL_PENDING" +
                    "&sortColumn=" +
                    this.sortColumn +
                    "&sortOrder=" +
                    this.sortOrder +
                    "&ecn=" +
                    this.ecn +
                    "&fromDate=" +
                    fromDate+
                    "&loggedUser="+
                    authService.getUser().id+
                    "&userId=" +
                    assignedBy,
                    auth
                )
                .then(result => {
                    this.totalRows = result.data.pageInfo.totalElements;
                    this.bidwantedList = result.data.content;
                    this.bidwantedList.forEach(bid => {
                        bid.isSelect = false
                    });
                    
                    this.loading = false;
                }).catch(() => this.loading = false);
        },
        getTraderList() {
            const auth = {
                headers: { "org-token": authService.getOrgToken() },
            };
            this.$http
                .get(
                config.baseUrlBidSide +
                    "/trader/list?page=1&size=1000&search=&status=&sortColumn=firstName&sortOrder=ASC&status=active&group=Trader",
                auth
                )
                .then((result) => {
                this.traderList = result.data.content;
                })
                .catch((e) => {
                console.log(e);
                });
        },

    },
    mounted() {
        this.getTraderList()
        this.getBidwantedList();
    }
};
</script>